<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs v-model:activeKey="activeKey" destroyInactiveTabPane>
        <a-tab-pane :key="1" tab="门店级别设置">
          <levelList v-on:gopage='gopage'></levelList>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="成长值设置">
          <setUps></setUps>
        </a-tab-pane>
        <a-tab-pane :key="3" tab="门店类型">
          <typeList></typeList>
        </a-tab-pane>
        <a-tab-pane :key="4" tab="门店成长值明细">
          <detailedList></detailedList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject } from "vue";
import levelList from './components/level_list';
import typeList from './components/type_list';
import setUps from './components/set_up';
import detailedList from './components/detailed';

export default {
  components: {levelList,typeList,detailedList,setUps },
  setup() {
    const activeKey = ref(1)
    const $route = inject('$route')
    const gopage = (type) =>{
      if(type == 'type'){
       activeKey.value = 3
      }else if(type == 'grow'){
       activeKey.value = 2
      }
    }
    onMounted(() => {
      activeKey.value = $route.query.active ? $route.query.active : 1
    });
    return {
      activeKey,
      gopage
    };
  },
};
</script>